// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body,\nhtml,\n#app {\n  height: 100%;\n}\n.menu-is-open {\n  overflow: hidden;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/navigation.vue"],"names":[],"mappings":"AACA;;;EAGI,YAAA;AAAJ;AAGA;EACI,gBAAA;AAAJ","sourcesContent":["\nbody,\nhtml,\n#app {\n    height: 100%;\n}\n\n.menu-is-open {\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
